import { GenerativeReplaceBackgroundVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { extractPublicIdFromUrl, useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useImageStore } from 'stores/ImageStore'
import { useState } from 'react'
import { generativeBackgroundReplace } from '@cloudinary/url-gen/actions/effect'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useCreateMediaObjects } from 'hooks/queries/mediaObjects/useCreateMediaObjects'
import { downloadFile } from 'common/Prose/nodeViews/Image/components/ImageVariant/utils'

export const GenerativeBackgroundReplaceVariant = (props: GenerativeReplaceBackgroundVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()
  const [prompt, setPrompt] = useState('')
  const { mutateAsync: createMediaObjects, isLoading } = useCreateMediaObjects()

  if (!cloudinary) return null

  const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    e.stopPropagation()
    if (e.key === 'Escape') {
      return
    } else if (e.key === 'Enter' && !e.shiftKey && prompt.trim().length > 0) {
      e.preventDefault()

      if (variant.image.getResourceType().split('/')[1] !== 'fetch') {
        variant.image.effect(generativeBackgroundReplace().prompt(prompt))
        imageStore.clearVariants()
        imageStore.createVariant({
          ...variant,
          url: variant.image.toURL(),
        })
        return
      }

      let variantUrl = variant.url
      const isCloudinaryHosted = extractPublicIdFromUrl(variantUrl) !== `uploads/${variantUrl}`

      if (!isCloudinaryHosted) {
        const file = await downloadFile(variant.url)
        const mediaObjects = await createMediaObjects([{ file, filename: file.name }])
        variantUrl = mediaObjects[0].source_url
      }

      const image = cloudinary.image(extractPublicIdFromUrl(variantUrl)).setDeliveryType('upload')
      image.effect(generativeBackgroundReplace().prompt(prompt))
      imageStore.clearVariants()
      imageStore.createVariant({
        ...variant,
        url: image.toURL(),
        image,
      })
    }
  }

  return (
    <ImageVariant {...props} isLoading={isLoading}>
      <Input
        placeholder="Ask Blaze to replace the background"
        autoFocus
        name="prompt"
        isTextarea
        value={prompt}
        onChange={(event) => setPrompt(event.target.value)}
        onKeyDown={handleKeyDown}
      />
    </ImageVariant>
  )
}
